import axios from 'axios'

const API_PATH = '/api/v2/admins/legacy_operations'

const LegacyOperationsApiV2 = {
  index: async (resource, params = {}) => axios.get(`${API_PATH}/${resource}`, { params }),

  show: async (resource, id, archived = false) => axios.get(`${API_PATH}/${resource}/${id}`, { params: { archived: String(archived) } }),

  options: async (resource, params = {}) => axios.get(`${API_PATH}/${resource}/options`, { params }),

  archive: async (resource, id) => axios.delete(`${API_PATH}/${resource}/${id}`),

  restore: async (resource, id) => axios.post(`${API_PATH}/${resource}/${id}/restore`),

  create: async (resource, payload) => axios.post(`${API_PATH}/${resource}`, payload),

  update: async (resource, id, payload) => axios.patch(`${API_PATH}/${resource}/${id}`, payload),

  confirm: async (resource, id) => axios.put(`${API_PATH}/${resource}/${id}/confirm`),

  reject: async (resource, id, rejectionNote = '') => axios.put(
    `${API_PATH}/${resource}/${id}/reject`,
    { rejection_note: rejectionNote }
  ),

  downloadTandaKeluarPdf: async (id) => axios.get(
    `${API_PATH}/tanda_keluars/${id}/download_pdf`,
    { responseType: 'blob' }
  )
}

export default LegacyOperationsApiV2
